import Input from "../../../Medicine-master/Component/Input";

export const ehrComplaintInput = [
  {
    tag: Input,
    img: "",
    label: "Complaint Name",
    name: "complaintName",
    validation: "required",
    required: true,
    key: "complaintName",
  },
  {
    tag: Input,
    img: "",
    label: "Complaints Description",
    name: "complaintsDescription",
    validation: "required",
    required: true,
    key: "complaintsDescription",
  },
];

export const ehrHandEInput = [
  {
    tag: Input,
    img: "",
    label: "Name",
    name: "name",
    validation: "required",
    required: true,
    key: "name",
  },
  {
    tag: Input,
    img: "",
    label: "Description",
    name: "description",
    validation: "required",
    required: true,
    key: "description",
    show:true
  },
];

export const ehrAdviceInput = [
  {
    tag: Input,
    img: "",
    label: "Complaint Name",
    name: "complaint",
    validation: "required",
    required: true,
    key: "complaint",
  },
  {
    tag: Input,
    img: "",
    label: "Advice",
    name: "advice",
    validation: "required",
    required: true,
    key: "advice",
  },
];

export const ehrDiagnosisInput = [
    {
      tag: Input,
      img: "",
      label: "Diagnosis",
      name: "diagnosis",
      validation: "required",
      required: true,
      key: "diagnosis",
    },
  ];